<template>
  <div>
    <el-card class="chart-card">
      <h1>Gru - 原生环境下的Pignoo管理器</h1>
      <p>
        <el-text>Gru身兼四职，它是Pignoo自带的：数据源接口、事务管理器、Pignoo工厂、Pignoo声明周期管理器。</el-text>
      </p>
      <h1>数据源接口</h1>
      <p>
        <el-text>Gru的构造方法中包含一个数据源（DataSource）参数，使用Gru可以反复构建Pignoo实例。</el-text>
        <el-text>相对的，直接构建BasePignoo传入的DataSource只会被Pignoo对象使用一次。</el-text>
        <br />
        <el-text>每个数据源，只需要对应创建一个Gru。大多数项目是单数据源的，所以大部分时候，Gru也可以是单例的。</el-text>
        <br />
        <el-text>一般情况，我们会使用连接池构造数据源，因此一个Gru实例承接的是一个连接池的作用。</el-text>
        <el-text>相对的，每个Pignoo实例仅代表一条JDBC连接、或者是一个事务，经过事务提交后，Pignoo的声明周期就结束了。</el-text>
      </p>
      <p>
        <el-text>如果是多数据源项目，建议给每个数据源实例构建一个Gru实例！</el-text>
        <el-text>Gru内做了单一DataSource实例代理多数据源写法的兼容，但真实数据源与Gru一一对应是Gru的标准用法。</el-text>
        <el-text>单一DataSource实例代理多数据源场景，建议给Gru也做个代理。</el-text>
      </p>
      <h1>事务管理器</h1>
      <p>
        <el-text>Gru可以方便得开启事务，且当遇到抛出RuntimeException时，事务会被回滚。</el-text>
      </p>
      <div>
        <pre><code class="language-java">{{ code1 }}</code></pre>
      </div>
      <h1>Pignoo工厂</h1>
      <p>
        <el-text>Pignoo工厂的作用不言而喻了。使用Gru后，无需手动new Pignoo，都是用过Gru获取的Pignoo实例。</el-text>
      </p>
      <h1>Pignoo声明周期管理器（Pignoo作用域）</h1>
      <p>
        <el-text>为什么要着重提及Pignoo的生命周期？不仅仅是因为事务的提交。</el-text>
      </p>
      <p>
        <el-text>（默认）开启PignooWriter代理的时候，当Proxy实例被传递出了Pignoo声明周期，setter方法修改数据的功能也会失效！</el-text>
        <el-text>无论是否开启事务，都遵循这一规则！</el-text>
      </p>
      <div>
        <pre><code class="language-java">{{ code2 }}</code></pre>
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  if (window.hljs) {
    window.hljs.highlightAll()
  }
})

const code1 = `gru.run(pignoo -> {
  // 非事务的操作
});
gru.runTransaction(pignoo -> {
  // 开启事务的操作
});
gru.runTransaction(pignoo -> {
  // Do something...
  int exception = 1/0; // 异常，触发回滚
});`

const code2 = `// 举例1
Pig pig = gru.run(pignoo -> {
  Pig p = pignoo.writer(Pig.class).getAny();
  p.setName("换个名字1"); // Pignoo作用域内，Update生效
  retun p;
});
pig.setName("换个名字2"); // Pignoo作用域外，不更新数据库

// 举例2
Pignoo pignoo = gru.run(pignoo -> {
  return pignoo;
});
pignoo.reader(Pig.class).getAny();// 不要将pignoo传递出gru外。退出run方法时，已经关闭了Pignoo，无法再使用了！`

</script>

<style lang="less"></style>